/* eslint-disable @typescript-eslint/naming-convention */
import EthereumNetwork from '@providers/EthereumNetwork'
import { THandleMint, THandleMintCallback } from '@providers/models'
import PolygonNetwork from '@providers/PolygonNetwork'
import { generalUtils, networkUtils } from '@providers/utils'
import { IAbiItem, ICoupon, __PLUS_TWENTY_PERCENT__ } from '@types'

const SAFE_MINT_GAS_MARGIN = 200000

// eslint-disable-next-line complexity
export const handleMint = async (
    provider: EthereumNetwork | PolygonNetwork,
    contractAbi: IAbiItem[],
    contractAddress: string,
    mintPrice: string,
    selectedOption: number,
    position: number,
    coupon: ICoupon,
    category: number,
    maxPerWallet: number,
    callback: THandleMintCallback,
): Promise<THandleMint> => {
    //await provider.getCurrentChainId((config.networks[network] as IEthereum)[blockchain])
    const web3 = provider.getCurrentProvider()
    const accounts = await provider.getCurrentAccount()
    const selectedAddress = accounts[0]

    const Ticket = provider.getWeb3Contract(contractAbi, contractAddress)

    const gasPrice = await web3.eth.getGasPrice()
    let resultMint: boolean
    try {
        const gasAmount = await Ticket.methods
            .safeMint(selectedAddress, selectedOption, position, category, coupon.r, coupon.s, coupon.v)
            .estimateGas({
                from: accounts[0],
                value: web3.utils.toWei(`${mintPrice}`, 'ether'),
            })

        callback({ type: 'feedback', message: 'Confirming payment...' })
        callback({
            type: 'gasFee',
            value: web3.utils.fromWei(
                ((gasAmount + SAFE_MINT_GAS_MARGIN) * (Number(gasPrice) * __PLUS_TWENTY_PERCENT__)).toFixed(0),
                'ether',
            ),
        })
        let oneMinuteTimeout: NodeJS.Timeout
        //SM: safeMint
        resultMint = await Ticket.methods
            .safeMint(selectedAddress, selectedOption, position, category, coupon.r, coupon.s, coupon.v)
            .send({
                from: selectedAddress, // user wallet
                value: web3.utils.toWei(`${mintPrice}`, 'ether'), // mint price (nft price)
                gas: gasAmount + SAFE_MINT_GAS_MARGIN, // gas amount estimated to complete the transaction with a margin of 200000
                gasPrice: (Number(gasPrice) * __PLUS_TWENTY_PERCENT__).toFixed(0), // current gas price
                // nonce: 123,
            })
            .on('transactionHash', (hash: string) => {
                callback({ type: 'hash', value: hash })
                callback({ type: 'sent' })
            })
            .on('receipt', async (receipt: Record<string, unknown>) => {
                callback({ type: 'mintResult', value: receipt })
                const assetInfo = await generalUtils.handleAssetInfo(receipt, Ticket)
                callback({ type: 'mintMetadata', value: assetInfo })
                callback({ type: 'message', message: 'Success...' })
                clearTimeout(oneMinuteTimeout)
            })

        if (!resultMint)
            return {
                success: false,
                error: 'Something went wrong',
            }

        return {
            success: true,
        }
    } catch (error: any) {
        console.log('Error:', error)

        const errorMessage = generalUtils.mintErrorTreatment(error)

        if (errorMessage.code === 'MAX_WALLET_LIMIT') {
            const { mintAllowed } = await networkUtils.ethereum.handleMintAllowed(
                provider,
                contractAbi,
                contractAddress,
                position,
            )
            const message = `You have minted ${mintAllowed} out of the maximum ${maxPerWallet} NFTs`

            return {
                success: false,
                error: message,
            }
        }

        return {
            success: false,
            error: errorMessage.message,
        }
    }
}
